import ApolloClient, { gql } from 'apollo-boost';

const client = new ApolloClient({
    uri: 'https://graphqlzero.almansi.me/api'
});
client.query({
    query: gql`
  {
    user(id: 5){
    posts {
      data {
        title
        body
      }
    }
  }
}
`}).then(response => {
        console.log(response.data);
    }).catch(err => {
        console.log(err);
    });